export default {"src":"/_next/static/media/book-off.a5a07e13.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};